import { queryOptions } from "@tanstack/react-query";
import * as attachmentsApi from "./attachments-api";
import type { AttachmentsByMessage, ResolvedAttachment } from "../attachments.types";

export const attachmentsQueries = {
  all: () => ["attachments"] as const,
  lists: () => [...attachmentsQueries.all(), "list"] as const,
  byRoom: (roomId: string, messageIds: string[]) =>
    queryOptions({
      queryKey: [...attachmentsQueries.lists(), "room", roomId] as const,
      queryFn: async () => {
        const attachmentsByMessage: AttachmentsByMessage = {};

        for (const messageId of messageIds) {
          attachmentsByMessage[messageId] = [];
        }

        if (!messageIds.length) {
          return attachmentsByMessage;
        }

        const messageAttachments = await attachmentsApi.listAttachmentsByMessages({
          messageIds,
        });

        const resolvedAttachments = await Promise.all(
          messageAttachments.map(async (attachment) => {
            const signedUrl = await attachmentsApi.getSignedAttachmentUrl({
              storagePath: attachment.storage_path,
            });

            return {
              ...attachment,
              signedUrl,
            } satisfies ResolvedAttachment;
          }),
        );

        for (const attachment of resolvedAttachments) {
          attachmentsByMessage[attachment.message_id].push(attachment);
        }

        return attachmentsByMessage;
      },
    }),
};
